import styled from 'styled-components';
import { zIndex } from 'variables';
import { useRootContainerReferenceStore } from '../hooks/useRootContainerReferenceStore';

const Container = styled.div`
    top: 0;
    position: fixed;
    z-index: ${zIndex.modal};
`;

export default function RootContainer() {
    return (
        <Container
            ref={(node) => {
                if (node) {
                    useRootContainerReferenceStore.setState(() => ({ ref: node }));
                }
            }}
        />
    );
}
